import {createContext, useCallback, useContext, useEffect, useState} from 'react';
import axios from "axios";
import {TokenContext} from "./TokenContext";
const UserContext = createContext(null)
const serverUrl = process.env.REACT_APP_SERVER_URL_API || 'http://localhost:8090';

function UserProvider({children}) {

    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(false);
    const _tokenContext = useContext(TokenContext)

    const refreshUserData = useCallback(() => {
        if (!_tokenContext.accessToken) return Promise.resolve();
        setLoading(true);
        return axios.get(`${serverUrl}/api/user`, {
            headers: {
                Authorization: `Bearer ${_tokenContext.accessToken}`
            },
        }).then((v) => {
            setUserInfo(v.data)
        }).finally(() => setLoading(false));
    }, [_tokenContext.accessToken]);

    useEffect(() => {
        if(!userInfo && _tokenContext.accessToken){
            refreshUserData();
        }
    }, [_tokenContext.accessToken, userInfo, refreshUserData]);


    return (
        <UserContext.Provider value={{ userInfo, loading, refreshUserData }}>
            {children}
        </UserContext.Provider>
    );
}

export {UserContext, UserProvider};
